(ns guidebook.views.strategies
  (:require
   [reagent.core :as r]
   [guidebook.common :refer [title-s body-s]]
   [cljss.core :as cljss]
   [main.common :as common]
   [guidebook.common :as gc]
   [css.vars :as vars]
   [oops.core :refer [oget]]
   [css.core :refer [defstyled get-theme]]
   [graphs.core :refer [data->colors]]
   ["recharts" :as recharts]
   [very.re-frame.core :as rf]))

(defstyled strategies-s :div
  {:padding "135px 0"
   :min-height "100vh"
   ::cljss/media {[:print]
                  {:padding "100px 0 170px"}}})

(defstyled strategies-info-s :div
  {:display "grid"
   :padding "0 100px"
   :grid-template-columns "1fr 1fr"
   :grid-gap "4rem 6rem"
   ::cljss/media {[:print]
                  {:grid-template-columns "80%"
                   :align-items "center"
                   :justify-content "center"}}})

(defstyled strategy-block-s :div
  {:grid-template-columns "min-content 1fr"
   :grid-column-gap "3rem"
   :display "grid"})

(defstyled strategy-percent-s :div
  {:background-color (with-meta identity :color)
   :width "70px"
   :height "70px"
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :font-size "1.18rem"
   :color "white"
   :border-radius "100%"})

(defstyled strategy-header-s :div
  {:border-bottom (str "1px solid " vars/border-light)
   :padding-bottom "1rem"
   :margin-bottom ".5rem"
   :display "grid"
   :grid-template-columns "1fr 150px"})

(defstyled strategy-title-s :h3
  {:font-size "2rem"
   :font-weight "500"
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0}}})

(defstyled strategy-logo-s :img
  {:max-width "100%"
   :max-height "65px"
   :justify-self "flex-end"})

(defstyled strategy-category-s :h4
  {:color vars/gray
   :font-size "1.18rem"
   :margin-bottom "1rem"
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-bottom ".5rem"}}})

(defn pie-chart []
  (let [responsive-container (r/adapt-react-class (oget recharts "ResponsiveContainer"))
        re-pie-chart (r/adapt-react-class (oget recharts "PieChart"))
        pie (r/adapt-react-class (oget recharts "Pie"))
        cell (r/adapt-react-class (oget recharts "Cell"))
        label-list (r/adapt-react-class (oget recharts "LabelList"))
        label (r/adapt-react-class (oget recharts "Label"))
        outer-radius 280]
    (fn [strategies id->color]
      [responsive-container {:height (+ (* 2 outer-radius) 200)
                             :width "100%"}
       [re-pie-chart {:on-mouse-leave #()}
        [pie {:data (clj->js strategies)
              :dataKey "percent"
              :innerRadius 210
              :outerRadius outer-radius
              :isAnimationActive false
              :on-click #()
              :paddingAngle 0}
         ;; Styling applied in index.html
         [label-list {:dataKey "name"
                      :position "outside"
                      :offset 40
                      :stroke "black"
                      :fill "black"}]
         (for [s strategies]
           ^{:key random-uuid}
           [cell {:fill (id->color (:name s))}])]]])))

(defn info [strat color]
  [strategy-block-s
   [strategy-percent-s {:color color} (str (:percent strat) "%")]
   [:div
    [strategy-header-s
     [:div
      [strategy-category-s (get-in strat [:category :name])]
      [strategy-title-s (:name strat)]]
     [strategy-logo-s {:src (:logo strat)}]]
    [gc/text (:description strat)]]])

(defn main []
  (let [strategies (rf/subscribe [:guidebook/strategies])]
    (fn []
      (let [id->color (data->colors @strategies :name)]
        [strategies-s
         [title-s {:margin "0 100px 2rem"} "Your Strategies"]
         [body-s {:margin "0 100px"} "These strategies provide a continuously managed portfolio that's aligned with your financial priorities."]
         [pie-chart @strategies id->color]
         (into [strategies-info-s] (map #(info % (id->color (:name %)))) @strategies)]))))
